module.exports = __webpack_public_path__ + "media/images/team/sabine-830d80f9a3f6f982b371794fa7e21467.jpg";